
import React, { useState, useEffect } from 'react';
import { Language } from '../types';
import { translations } from '../translations';

interface CookieConsentProps {
  lang: Language;
  onOpenPolicy: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ lang, onOpenPolicy }) => {
  const [isVisible, setIsVisible] = useState(false);
  const t = translations[lang].cookie;

  useEffect(() => {
    const consent = localStorage.getItem('axiomity-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('axiomity-cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('axiomity-cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-[200] animate-in fade-in slide-in-from-bottom-10 duration-700">
      <div className="apple-blur border border-white/10 rounded-2xl p-6 shadow-2xl shadow-black/50">
        <div className="flex items-start gap-4">
          <div className="bg-sky-500/10 p-2 rounded-lg shrink-0"><svg className="w-6 h-6 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg></div>
          <div className="space-y-3">
            <h4 className="text-sm font-bold text-white uppercase tracking-widest">{t.title}</h4>
            <p className="text-xs text-gray-400 leading-relaxed">
              {t.desc} <button onClick={onOpenPolicy} className="text-sky-400 hover:underline">política de cookies</button>.
            </p>
            <div className="flex items-center gap-3 pt-2">
              <button onClick={handleAccept} className="flex-1 bg-white text-black text-[10px] font-black uppercase tracking-widest py-3 rounded-lg hover:bg-gray-200 transition-colors">{t.accept}</button>
              <button onClick={handleDecline} className="flex-1 bg-white/5 text-gray-400 text-[10px] font-black uppercase tracking-widest py-3 rounded-lg border border-white/10 hover:bg-white/10 transition-colors">{t.necessary}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
